/* eslint-disable consistent-return */
import React, { useState, memo, useRef, useEffect } from "react";

// TODO: Fix autofocus issue with React. Might need to use useRef hook.
const VerificationCodeInput = ({
  value = "",
  onChange,
  disabled = false,
  style,
  fontSize = 3
}) => {
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);

  const focusedStyle = {
    color: "inherit"
  };

  useEffect(() => {
    inputRef.current?.focus();
  }, []);
  
  const generateStyle = (length) => {
    return {
      display: "inline-block",
      border: "none",
      width: `${length + length * 0.49}ch`,
      background:
        "repeating-linear-gradient(90deg, dimgrey 0, dimgrey 1ch, transparent 0, transparent 1.5ch) 0 100%/100% 2px no-repeat",
      color: "dimgrey",
      font: `${fontSize}ch gilroy`,
      letterSpacing: ".59ch",
      fontWeight: 600,
      outline: "none",
      fontVariantNumeric: "tabular-nums",
    };
  };

  return (
    <div style={style}>
      <input
        ref={inputRef}
        className="no-spin"
        type="text"
        pattern="[0-9]*"
        inputMode="numeric"
        value={value}
        style={{
          ...generateStyle(5),
          ...(focused && !disabled && { ...focusedStyle }),
          paddingLeft: "0.5px"
        }}
        onFocus={() => {
          setFocused(true);
        }}
        onBlur={() => {
          setFocused(false);
        }}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        maxLength={5}
        onKeyDown={(e) => {
          const allowed = ["Backspace", "ArrowLeft", "ArrowRight"];
          const isPasting = e.key === "v" && (e.ctrlKey || e.metaKey);
          if (!allowed.includes(e.key) && !/[0-9]/g.test(e.key) && !isPasting) {
            e.preventDefault();
            e.returnValue = false; // IE
            return false;
          }
        }}
        onKeyUp={(e) => {
          const ignore = ["Backspace", "ArrowLeft", "ArrowRight"];
          if (ignore.includes(e.key) || !/[0-9]/g.test(e.key)) {
            e.preventDefault();
            e.returnValue = false; // IE
            return false;
          }
          onChange(e.target.value);
        }}
        onPaste={(e) => {
          e.preventDefault();
          const pastedData = e.clipboardData.getData("text");
          if (/^[0-9]+$/.test(pastedData)) {
            onChange(pastedData);
          }
        }}
        disabled={disabled}
      />
    </div>
  );
}

export default memo(VerificationCodeInput);
